module.exports = __webpack_public_path__ + "img/init.39dacb23.png";